/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./arena.vue?vue&type=template&id=735d8f51&scoped=true"
import script from "./arena.vue?vue&type=script&lang=js"
export * from "./arena.vue?vue&type=script&lang=js"
import style1 from "./arena.vue?vue&type=style&index=1&id=735d8f51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735d8f51",
  null
  
)

export default component.exports